// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileFeed-cls1_ZrZ","cls2":"ProfileFeed-cls2_s7s ProfileFeed-cls1_ZrZ"};